/** Usuario que puede marcar ficha lista / publicar skill (Miguel). */
export const SKILLS_APPROVER_USERNAMES = ["miguel"];

export function isSkillsApprover(user = {}, decodedToken = {}) {
  const username = String(
    user?.username || decodedToken?.username || "",
  )
    .trim()
    .toLowerCase();
  return SKILLS_APPROVER_USERNAMES.includes(username);
}

export const LOCK_TTL_MS = 5 * 60 * 1000;

export function isLockActive(row, now = Date.now()) {
  if (!row?.EditLockUserId || !row?.EditLockAt) return false;
  const at = new Date(row.EditLockAt).getTime();
  if (Number.isNaN(at)) return false;
  return now - at < LOCK_TTL_MS;
}

export function workflowStep(status, designCompletedAt) {
  if (status === "published" || status === "skill_created") return 4;
  if (status === "ready") return 3;
  if (designCompletedAt || status === "design_done") return 2;
  return 1;
}

export const WORKFLOW_STEPS = [
  { key: 1, label: "En curso", hint: "Diseño rellena la ficha" },
  { key: 2, label: "Terminada", hint: "Diseño ha dado el OK" },
  { key: 3, label: "Validada", hint: "Miguel la marca lista" },
  { key: 4, label: "Skill publicado", hint: "Versión activa para agentes" },
];

export function statusDisplay(row) {
  if (row?.Status === "published" || row?.Status === "skill_created") {
    return { label: "Skill publicado", color: "info" };
  }
  if (row?.Status === "ready") return { label: "Lista para publicar", color: "success" };
  if (row?.DesignCompletedAt || row?.Status === "design_done") {
    return { label: "Terminada por Diseño", color: "warning" };
  }
  if (isLockActive(row)) {
    return {
      label: `Editando: ${row.EditLockUsername || "alguien"}`,
      color: "default",
    };
  }
  return { label: "En curso", color: "default" };
}

export const TASK_STATUS_LABELS = {
  draft: "Borrador",
  queued: "En cola",
  running: "Ejecutando",
  needs_review: "Pendiente revisión",
  done: "Hecha",
  failed: "Fallida",
  cancelled: "Cancelada",
};

export const TASK_TYPE_LABELS = {
  presentacion: "Presentación",
  propuestas: "Propuestas",
  siluetas: "Siluetas",
  mood: "Mood / story",
  revision: "Revisión",
  otro: "Otro",
};

export function taskStatusColor(status) {
  switch (status) {
    case "done":
      return "success";
    case "needs_review":
      return "warning";
    case "running":
    case "queued":
      return "info";
    case "failed":
      return "error";
    case "cancelled":
      return "default";
    default:
      return "default";
  }
}
